import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { KeycloakAngularModule } from 'keycloak-angular';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { graphqlProvider } from './utils/apollo-init';
import { environment } from '../environments/environment';
import { TranslationsLoader } from './modules/shared/services/translations.loader';
import { keycloakInitializer } from './utils/app-init';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { themeConfig } from './modules/shared/services/theme';
import { ThemeModule } from '@wind-log_library/fe-component-library';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { UserAccessService } from '@services/user-access/user-access.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    graphqlProvider,
    keycloakInitializer(),
    UserAccessService,
    {
      provide: 'environment',
      useValue: environment,
    },
    provideHttpClient(),
    importProvidersFrom(
      KeycloakAngularModule,
      ModalModule.forRoot(),
      BsDropdownModule.forRoot(),
      ThemeModule.forRoot(themeConfig),
      PopoverModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslationsLoader,
          deps: [HttpClient],
        },
      }),
    ),
    provideAnimationsAsync(),
  ],
};
